import { Event, Market, Option } from '@/feature/event-details-sbk/types';

import { SelectionParam } from '../types';

// the odds passed in become both `odds` and `originalOdds`, so callers substituting
// live values spread them on first
export const toSelectionParam = (
    option: Pick<Option, 'id' | 'description' | 'odds' | 'option_type' | 'status'>,
    market: Pick<
        Market,
        'id' | 'description' | 'market_type' | 'player' | 'is_micro_market' | 'published' | 'supplier'
    >,
    event: Pick<
        Event,
        'id' | 'start_time' | 'home_team' | 'away_team' | 'is_sgp_enabled' | 'sport' | 'event_details' | 'status'
    >
): SelectionParam => ({
    option: {
        id: option.id,
        description: option.description,
        odds: option.odds,
        originalOdds: option.odds,
        marketId: market.id,
        optionType: option.option_type,
        status: option.status,
    },
    market: {
        id: market.id,
        description: market.description,
        eventId: event.id,
        marketType: market.market_type,
        player: market.player,
        isMicroMarket: market.is_micro_market,
        published: market.published,
        supplier: market.supplier,
    },
    event: {
        id: event.id,
        start_time: event.start_time,
        home_team: event.home_team,
        away_team: event.away_team,
        is_sgp_enabled: event.is_sgp_enabled,
        sport: event.sport,
        event_details: event.event_details,
        status: event.status,
    },
});
